import VERTEX_SHADER from "../shaders/ground/ground-plane.vs";
import FRAGMENT_SHADER from "../shaders/ground/ground-plane.fs";

class MaterialGroundPlane extends THREE.ShaderMaterial {
    /**
     * 
     * @param {THREE.WebGLRenderTarget} shadowMap 
     * @param {number} samples
     */
    constructor(shadowMap, samples, directions, quality, size, useGaussian) {
        const defines = {
            USE_PERSPECTIVE_CAMERA: "",
            USE_SHADOWMAP: "",
            NUM_DIR_LIGHTS: 1,
            SAMPLE_COUNT: samples,
            DIRECTIONS: directions.toFixed(32),
            QUALITY: quality.toFixed(32),
            SIZE: size.toFixed(32),
        };

        if (!useGaussian) defines.USE_SIMPLE_SHADOWS = "";

        const uniforms = {
            directionalLights: new THREE.Uniform([{
                direction: new THREE.Vector3(0, 1, 0),
                color: new THREE.Color(0x000000),
                opacity: 0,
                shadowBias: 0,
                shadowMapSize: new THREE.Vector2(shadowMap.width, shadowMap.height),
                shadowRadius: 1.5
            }]),
            directionalShadowMap: new THREE.Uniform([shadowMap.texture]),
            directionalShadowMatrix: new THREE.Uniform([new THREE.Matrix4()])
        };

        super({
            defines,
            uniforms,
            vertexShader: VERTEX_SHADER,
            fragmentShader: FRAGMENT_SHADER,
            depthWrite: false,
            transparent: true,
            // blending: THREE.AdditiveBlending
        });
    }

    get shadowMatrix() { return this.uniforms.directionalShadowMatrix.value[0]; }
    get shadowMap() { return this.uniforms.directionalShadowMap.value[0]; }
    get shadowColor() { return this.uniforms.directionalLights.value[0].color; }

    get shadowOpacity() { return this.uniforms.directionalLights.value[0].opacity; }
    set shadowOpacity(value) { this.uniforms.directionalLights.value[0].opacity = value; }

    get shadowRadius() { return this.uniforms.directionalLights.value[0].shadowRadius; }
    set shadowRadius(value) { this.uniforms.directionalLights.value[0].shadowRadius = value; }

    /**
     * 
     * @param {THREE.Camera} camera 
     */
    updateCamera(shadowCamera) {
        this
            .shadowMatrix
            .set(
                0.5, 0.0, 0.0, 0.5,
                0.0, 0.5, 0.0, 0.5,
                0.0, 0.0, 0.5, 0.5,
                0.0, 0.0, 0.0, 1.0
            )
            .multiply(shadowCamera.projectionMatrix)
            .multiply(shadowCamera.matrixWorldInverse);
    }
}

export default MaterialGroundPlane;
export { MaterialGroundPlane };